import { css } from '@emotion/react'

export const buttons = css`
  display: flex;
  gap: 24px;

  button {
    flex: 1;
  }
`
